(function () {
  const root = document.querySelector("[data-dco-order]");
  if (!root) return;

  document.body.classList.add("dco-order-active");
  document.documentElement.classList.add("dco-order-html-active");

  const locale = root.dataset.locale && root.dataset.locale.indexOf("en") === 0 ? "en" : "vi";
  const minimum = Number(root.dataset.minimumCents || 11500);
  const shipping = Number(root.dataset.shippingCents || 14800);
  const gift = Number(root.dataset.giftCents || 20000);
  const checkoutUrl = "/checkout?locale=en";
  const legacyCheckoutTitleProperties = new Set(["Món / Item", "Mon / Item", "Món", "Mon", "Item", "_dco_checkout_title"]);
  const productScript = document.getElementById(root.dataset.productsId);
  const products = productScript ? JSON.parse(productScript.textContent) : [];
  const productByVariant = new Map(products.map((product) => [String(product.variantId), product]));
  const strings = {
    vi: {
      empty: "Giỏ hàng đang trống.",
      items: "món",
      subtotal: "Tạm tính",
      ship: "Phí ship",
      free: "Miễn phí",
      gift: "5 Chả Ốc + 1 Giò Thủ",
      remainingMinimum: "Còn {amount} để checkout.",
      remainingShipping: "Đã đủ checkout. Thêm {amount} để được free overnight shipping.",
      remainingGift: "Đã free ship. Thêm {amount} nhận quà.",
      complete: "Đã được free overnight shipping + quà tặng.",
      nextGift: "Đã nhận quà. Thêm {amount} nhận thêm quà.",
      bottomMinimum: "Còn {amount} để checkout",
      bottomShipping: "Thêm {amount} để được free ship",
      bottomGift: "Thêm {amount} để nhận quà",
      bottomComplete: "Đã được free ship + quà tặng",
      bottomNextGift: "Thêm {amount} nhận thêm quà",
      giftNudge: "Thêm {amount} nhận quà",
      minimumTierPending: "Minimum order (+$10 shipping)",
      minimumTierReached: "Minimum order",
      locked: "Thêm {amount} để checkout",
      checkout: "Checkout",
      checkoutLoading: "Đang mở checkout...",
      minWarning: "Thêm {amount} nữa để checkout. Đơn ship tối thiểu $115.",
      cartError: "Không cập nhật được giỏ hàng. Vui lòng thử lại hoặc text/call 469-644-4086.",
      cartErrorBottom: "Không cập nhật được giỏ hàng. Thử lại.",
      remove: "Xóa",
      decrease: "Giảm số lượng",
      increase: "Tăng số lượng",
      chooseQuantity: "Chọn số lượng",
      orderMore: "Tiếp tục đặt món",
      storage: "Bảo quản",
      reheating: "Cách dùng",
      allergens: "Lưu ý dị ứng"
    },
    en: {
      empty: "Your cart is empty.",
      items: "items",
      subtotal: "Subtotal",
      ship: "Shipping",
      free: "Free",
      gift: "5 Cha Oc + 1 Gio Thu",
      remainingMinimum: "Add {amount} to checkout.",
      remainingShipping: "Minimum reached. Add {amount} for free overnight shipping.",
      remainingGift: "Free shipping reached. Add {amount} for the gift.",
      complete: "Free overnight shipping + gift unlocked.",
      nextGift: "Gift unlocked. Add {amount} for another gift.",
      bottomMinimum: "Add {amount} to checkout",
      bottomShipping: "Add {amount} for free shipping",
      bottomGift: "Add {amount} for the gift",
      bottomComplete: "Free shipping + gift unlocked",
      bottomNextGift: "Add {amount} for another gift",
      giftNudge: "Add {amount} for gift",
      minimumTierPending: "Minimum order (+$10 shipping)",
      minimumTierReached: "Minimum order",
      locked: "Add {amount} to checkout",
      checkout: "Checkout",
      checkoutLoading: "Opening checkout...",
      minWarning: "Add {amount} more to checkout. Shipping orders need at least $115.",
      cartError: "Could not update your cart. Please try again or call/text 469-644-4086.",
      cartErrorBottom: "Cart did not update. Try again.",
      remove: "Remove",
      decrease: "Decrease quantity",
      increase: "Increase quantity",
      chooseQuantity: "Choose quantity",
      orderMore: "Order more items",
      storage: "Storage",
      reheating: "Preparation",
      allergens: "Allergy notes"
    }
  }[locale];

  let cart = { items: [], item_count: 0, total_price: 0, currency: "USD", note: "" };
  const cartOrderStorageKey = "dcoCartLineOrder";
  const quantityTimers = new Map();
  const desiredQuantities = new Map();
  let syncedQuantities = new Map();
  let cartLineOrder = readCartLineOrder();
  let renderedLineStructure = "";
  let renderScheduled = false;
  let pendingScrollRestore = null;
  let pendingScrollRestoreUntil = 0;
  let drawerScrollY = 0;
  let drawerScrollLocked = false;
  let drawerBodyScrollSnapshot = null;
  let drawerHtmlScrollSnapshot = null;
  let drawerTouchStartY = 0;
  let drawerTouchStartX = 0;
  let drawerTouchLastY = 0;
  let drawerSwipeActive = false;
  let drawerSwipeDistance = 0;
  let lastDetailsTrigger = null;
  let detailsScrollX = 0;
  let detailsScrollY = 0;
  let detailsScrollLocked = false;
  let detailsUsesFixedScrollLock = false;
  let bodyScrollSnapshot = null;
  let htmlScrollSnapshot = null;
  let detailsTouchStartY = 0;
  let detailsTouchStartX = 0;
  let detailsTouchLastY = 0;
  let detailsSwipeActive = false;
  let detailsSwipeDistance = 0;
  let syncedNote = "";
  let noteDirty = false;
  let noteSyncTimer = null;
  let noteSyncPromise = null;
  let checkoutRequestActive = false;
  let checkoutHandoffActive = false;
  let checkoutHandoffTimer = null;
  let cartSyncTimer = null;
  let cartSyncPromise = null;
  let cartSyncDirty = false;

  const frame = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : (callback) => window.setTimeout(callback, 16);

  const nodes = {
    cartLines: [...root.querySelectorAll("[data-dco-cart-lines]")],
    counts: [...root.querySelectorAll("[data-dco-count]")],
    subtotals: [...root.querySelectorAll("[data-dco-subtotal]")],
    shipping: [...root.querySelectorAll("[data-dco-shipping]")],
    messages: [...root.querySelectorAll("[data-dco-message]")],
    bottomMessages: [...root.querySelectorAll("[data-dco-bottom-message]")],
    checkoutButtons: [...root.querySelectorAll("[data-dco-checkout]")],
    checkouts: [...root.querySelectorAll("[data-dco-checkout-label]")],
    checkoutCounts: [...root.querySelectorAll("[data-dco-checkout-count]")],
    giftRows: [...root.querySelectorAll("[data-dco-gift-row]")],
    giftValues: [...root.querySelectorAll("[data-dco-gift-value]")],
    giftTier: root.querySelector("[data-dco-gift-tier]"),
    giftTierLabels: [...root.querySelectorAll("[data-dco-gift-tier-label]")],
    giftTierValues: [...root.querySelectorAll("[data-dco-gift-tier-value]")],
    minimumTierLabels: [...root.querySelectorAll("[data-dco-minimum-tier-label]")],
    promoFills: [...root.querySelectorAll("[data-dco-promo-fill]")],
    promoMarkers: [...root.querySelectorAll("[data-dco-promo-marker]")],
    tiers: [...root.querySelectorAll("[data-dco-tier]")],
    warnings: [...root.querySelectorAll("[data-dco-warning]")],
    notes: [...root.querySelectorAll("[data-dco-note]")],
    drawer: root.querySelector("[data-dco-drawer]"),
    drawerBody: root.querySelector("[data-dco-drawer-body]"),
    drawerBackdrop: root.querySelector("[data-dco-drawer-backdrop]"),
    detailsModal: root.querySelector("[data-dco-details-modal]"),
    detailsBackdrop: root.querySelector("[data-dco-details-backdrop]"),
    detailsTitle: root.querySelector("[data-dco-details-title]"),
    detailsBody: root.querySelector("[data-dco-details-body]"),
    detailsFooter: root.querySelector("[data-dco-details-footer]")
  };

  syncedNote = nodes.notes[0]?.value || "";

  const productNodes = new Map();
  products.forEach((product) => {
    const id = String(product.variantId);
    const cards = [...root.querySelectorAll(`[data-dco-product-card][data-variant-id="${id}"]`)];
    const inputs = cards.flatMap((card) => [...card.querySelectorAll("[data-dco-qty-input]")]);
    productNodes.set(id, { cards, inputs });
  });

  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[char]));
  }

  function formatText(value) {
    return escapeHtml(value).replace(/\n/g, "<br>");
  }

  function setText(targets, value) {
    targets.forEach((node) => {
      if (node.textContent !== value) node.textContent = value;
    });
  }

  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    frame(() => {
      renderScheduled = false;
      restoreScrollAfterQuantityChange();
      render();
      restoreScrollAfterQuantityChange();
      frame(restoreScrollAfterQuantityChange);
    });
  }

  function money(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: cart.currency || "USD",
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);
  }

  function template(text, amount) {
    return text.replace("{amount}", money(amount));
  }

  function quantityFor(variantId) {
    const line = cart.items.find((item) => String(item.id) === String(variantId));
    return line ? line.quantity : 0;
  }

  function displayedQuantityFor(variantId) {
    const id = String(variantId);
    return desiredQuantities.has(id) ? desiredQuantities.get(id) : quantityFor(id);
  }

  function giftMultiplier(total) {
    if (gift <= 0 || total < gift) return 0;
    return Math.floor(total / gift);
  }

  function giftDescription(multiplier) {
    const count = Math.max(1, multiplier);
    const chaOcCount = 5 * count;
    return locale === "en"
      ? `${chaOcCount} Cha Oc + ${count} Gio Thu`
      : `${chaOcCount} Chả Ốc + ${count} Giò Thủ`;
  }

  function promoGiftDescription(multiplier) {
    return locale === "en"
      ? `Get ${giftDescription(multiplier)}`
      : `Tặng ${giftDescription(multiplier)}`;
  }

  function nextGiftAmount(total) {
    const multiplier = giftMultiplier(total);
    if (!multiplier) return 0;
    return ((multiplier + 1) * gift) - total;
  }

  function nextMilestoneText(total) {
    if (total < minimum) return template(strings.remainingMinimum, minimum - total);
    if (total < shipping) return template(strings.remainingShipping, shipping - total);
    if (total < gift) return template(strings.remainingGift, gift - total);
    if (nextGiftAmount(total) > 0) return template(strings.nextGift, nextGiftAmount(total));
    return strings.complete;
  }

  function bottomText(total) {
    if (total < minimum) return template(strings.bottomMinimum, minimum - total);
    if (total < shipping) return template(strings.bottomShipping, shipping - total);
    if (total < gift) return template(strings.bottomGift, gift - total);
    if (nextGiftAmount(total) > 0) return template(strings.bottomNextGift, nextGiftAmount(total));
    return strings.bottomComplete;
  }

  function milestoneState(total) {
    if (total >= gift) return "gift";
    if (total >= shipping) return "shipping";
    if (total >= minimum) return "minimum";
    return "locked";
  }

  function progress(total) {
    if (total <= 0) return 0;
    return Math.min(100, Math.round((total / gift) * 100));
  }

  function normalizeQuantity(value, step) {
    const parsed = Math.max(0, parseInt(value, 10) || 0);
    if (parsed === 0) return 0;
    if (Number(step) === 2 && parsed % 2 !== 0) return parsed + 1;
    return parsed;
  }

  function shouldPreservePageScroll() {
    if (!window.matchMedia || !window.matchMedia("(max-width: 749px)").matches) return false;
    if (nodes.drawer?.classList.contains("is-open")) return false;
    if (nodes.detailsModal?.classList.contains("is-open")) return false;
    return true;
  }

  function isMobileSheetViewport() {
    return !window.matchMedia || window.matchMedia("(max-width: 749px)").matches;
  }

  function captureScrollBeforeQuantityChange() {
    clearPendingScrollRestore();
  }

  function clearPendingScrollRestore() {
    pendingScrollRestore = null;
    pendingScrollRestoreUntil = 0;
  }

  function cancelScrollRestoreAfterUserMove() {
    if (!pendingScrollRestore) return;
    clearPendingScrollRestore();
  }

  function captureScrollBeforeQuantityPointer(event) {
    if (!event.target.closest("[data-dco-plus], [data-dco-minus], [data-dco-remove]")) return;
    captureScrollBeforeQuantityChange();
  }

  function releaseQuantityButtonFocus(button) {
    if (!button || typeof button.blur !== "function") return;
    frame(() => {
      if (document.activeElement === button) button.blur();
    });
  }

  function restoreScrollAfterQuantityChange() {
    clearPendingScrollRestore();
  }

  function linePrice(item) {
    return Number(item.final_price || item.price || item.original_price || 0);
  }

  function cartItemId(item) {
    return String(item.id);
  }

  function cartItemTitle(item) {
    const product = productByVariant.get(cartItemId(item));
    return product?.title || item.product_title || item.title || "";
  }

  function normalizePropertyText(value) {
    return String(value || "")
      .normalize("NFKC")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();
  }

  function titleCandidatesForItem(item) {
    const product = productByVariant.get(cartItemId(item));
    return [product?.title, item.product_title, item.title]
      .filter(Boolean)
      .flatMap((title) => String(title).split("/"))
      .map(normalizePropertyText)
      .filter(Boolean);
  }

  function isLegacyCheckoutProperty(key, value, item) {
    const cleanKey = String(key || "").trim().replace(/:$/, "");
    if (legacyCheckoutTitleProperties.has(cleanKey)) return true;

    const normalizedKey = normalizePropertyText(cleanKey);
    const normalizedValue = normalizePropertyText(value);
    if (cleanKey[0] === "_" && normalizedKey.indexOf("dco") !== -1) return true;
    if (!normalizedValue && cleanKey[0] !== "_") return true;

    const titleCandidates = titleCandidatesForItem(item);
    if (titleCandidates.includes(normalizedKey)) return true;
    return titleCandidates.includes(normalizedValue) && /mon|món|item|title/.test(normalizedKey);
  }

  function cleanLegacyLineProperties(item) {
    const properties = item?.properties;
    if (!properties || typeof properties !== "object" || Array.isArray(properties)) return null;

    const cleaned = {};
    let changed = false;
    Object.entries(properties).forEach(([key, value]) => {
      if (isLegacyCheckoutProperty(key, value, item)) {
        changed = true;
        return;
      }
      cleaned[key] = value;
    });

    return changed ? cleaned : null;
  }

  function readCartLineOrder() {
    try {
      const parsed = JSON.parse(window.sessionStorage?.getItem(cartOrderStorageKey) || "[]");
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeCartLineOrder() {
    try {
      if (cartLineOrder.length) {
        window.sessionStorage?.setItem(cartOrderStorageKey, JSON.stringify(cartLineOrder));
      } else {
        window.sessionStorage?.removeItem(cartOrderStorageKey);
      }
    } catch (error) {
      // Session storage is only a convenience for reloads; the in-memory order still works.
    }
  }

  function orderCartItems() {
    if (!Array.isArray(cart.items)) cart.items = [];

    const ids = cart.items.map(cartItemId);
    const activeIds = new Set(ids);
    const orderedIds = new Set();

    if (!cartLineOrder.length) {
      cartLineOrder = ids;
    } else {
      cartLineOrder = cartLineOrder.filter((id) => {
        if (!activeIds.has(id) || orderedIds.has(id)) return false;
        orderedIds.add(id);
        return true;
      });

      ids.forEach((id) => {
        if (orderedIds.has(id)) return;
        orderedIds.add(id);
        cartLineOrder.push(id);
      });
    }

    const orderIndex = new Map(cartLineOrder.map((id, index) => [id, index]));
    cart.items.sort((a, b) => orderIndex.get(cartItemId(a)) - orderIndex.get(cartItemId(b)));

    if (!cart.items.length) cartLineOrder = [];
    writeCartLineOrder();
  }

  function recalculateCart() {
    cart.items = cart.items.filter((item) => Number(item.quantity || 0) > 0);
    orderCartItems();
    cart.item_count = cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    cart.total_price = cart.items.reduce((sum, item) => {
      return sum + (Number(item.quantity || 0) * linePrice(item));
    }, 0);
  }

  function updateSyncedQuantities() {
    syncedQuantities = new Map(cart.items.map((item) => [String(item.id), Number(item.quantity || 0)]));
  }

  function setCartQuantity(variantId, quantity) {
    const id = String(variantId);
    const safeQuantity = Math.max(0, Number(quantity || 0));
    const line = cart.items.find((item) => String(item.id) === id);

    if (safeQuantity === 0) {
      cart.items = cart.items.filter((item) => String(item.id) !== id);
      recalculateCart();
      return;
    }

    if (line) {
      line.quantity = safeQuantity;
      recalculateCart();
      return;
    }

    const product = productByVariant.get(id);
    if (!product) return;
    cart.items.push({
      id: Number.isFinite(Number(id)) ? Number(id) : id,
      product_title: product.title,
      quantity: safeQuantity,
      final_price: Number(product.price || 0)
    });
    recalculateCart();
  }

  function displayCartItems() {
    const items = Array.isArray(cart.items) ? cart.items.map((item) => ({ ...item })) : [];
    const byId = new Map(items.map((item) => [cartItemId(item), item]));

    desiredQuantities.forEach((quantity, id) => {
      const safeQuantity = Math.max(0, Number(quantity || 0));
      const existing = byId.get(String(id));

      if (safeQuantity === 0) {
        if (existing) existing.quantity = 0;
        return;
      }

      if (existing) {
        existing.quantity = safeQuantity;
        return;
      }

      const product = productByVariant.get(String(id));
      if (!product) return;
      const item = {
        id: Number.isFinite(Number(id)) ? Number(id) : id,
        product_title: product.title,
        quantity: safeQuantity,
        final_price: Number(product.price || 0)
      };
      items.push(item);
      byId.set(String(id), item);
    });

    const orderIndex = new Map(cartLineOrder.map((id, index) => [String(id), index]));
    return items
      .filter((item) => Number(item.quantity || 0) > 0)
      .sort((a, b) => {
        const aIndex = orderIndex.has(cartItemId(a)) ? orderIndex.get(cartItemId(a)) : Number.MAX_SAFE_INTEGER;
        const bIndex = orderIndex.has(cartItemId(b)) ? orderIndex.get(cartItemId(b)) : Number.MAX_SAFE_INTEGER;
        return aIndex - bIndex;
      });
  }

  function displayCartSummary() {
    const items = displayCartItems();
    return {
      count: items.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
      total: items.reduce((sum, item) => sum + (Number(item.quantity || 0) * linePrice(item)), 0)
    };
  }

  function cleanupDesiredQuantities() {
    desiredQuantities.forEach((quantity, id) => {
      if (quantity === (syncedQuantities.get(id) || 0)) desiredQuantities.delete(id);
    });
  }

  function applyPendingQuantities() {
    desiredQuantities.forEach((quantity, id) => {
      if (quantity !== (syncedQuantities.get(id) || 0)) setCartQuantity(id, quantity);
    });
  }

  function applyOptimisticQuantity(variantId, quantity) {
    const id = String(variantId);
    if (quantity === displayedQuantityFor(id) && quantity === (syncedQuantities.get(id) || 0)) return;
    if (quantity === displayedQuantityFor(id) && desiredQuantities.get(id) === quantity) return;
    desiredQuantities.set(id, quantity);
    setCartQuantity(id, quantity);
    scheduleRender();
  }

  function clearWarnings() {
    nodes.warnings.forEach((node) => {
      if (node.textContent) node.textContent = "";
      if (node.classList.contains("is-visible")) node.classList.remove("is-visible");
    });
  }

  function showCartError(message) {
    const text = message || strings.cartError;
    setText(nodes.bottomMessages, strings.cartErrorBottom);
    nodes.warnings.forEach((node) => {
      if (node.textContent !== text) node.textContent = text;
      if (!node.classList.contains("is-visible")) node.classList.add("is-visible");
    });
  }

  async function fetchCart(options = {}) {
    const response = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
    cart = await response.json();
    if (!noteDirty && !noteSyncPromise) syncedNote = cart.note || "";
    orderCartItems();
    updateSyncedQuantities();
    if (options.preservePending) applyPendingQuantities();
    cleanupDesiredQuantities();
    scheduleRender();
  }

  function clearCartSyncTimer() {
    if (cartSyncTimer) window.clearTimeout(cartSyncTimer);
    cartSyncTimer = null;
  }

  function handleCartSyncError(error) {
    console.error("[DCO] Cart update failed", error);
    showCartError(strings.cartError);
    fetchCart({ preservePending: true }).catch(() => render());
  }

  function scheduleCartSync(variantId, delay = 180) {
    if (!variantId && desiredQuantities.size === 0) return;

    if (cartSyncPromise) {
      cartSyncDirty = true;
      return;
    }

    clearCartSyncTimer();
    cartSyncTimer = window.setTimeout(() => {
      cartSyncTimer = null;
      syncPendingQuantities().catch(handleCartSyncError);
    }, delay);
  }

  async function syncOneQuantity(variantId) {
    const id = String(variantId);
    if (!desiredQuantities.has(id)) return;

    const desired = desiredQuantities.get(id);
    const synced = syncedQuantities.get(id) || 0;
    if (desired === synced) {
      desiredQuantities.delete(id);
      return;
    }

    const endpoint = synced === 0 && desired > 0 ? "/cart/add.js" : "/cart/change.js";
    const line = cart.items.find((item) => cartItemId(item) === id);
    const body = endpoint === "/cart/add.js"
      ? { id, quantity: desired }
      : { id: line?.key || id, quantity: desired };
    const response = await fetch(endpoint, {
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);

    await fetchCart({ preservePending: true });
    document.dispatchEvent(new CustomEvent("cart:build"));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

    if (desiredQuantities.has(id) && desiredQuantities.get(id) !== (syncedQuantities.get(id) || 0)) {
      cartSyncDirty = true;
    }
  }

  async function syncPendingQuantities() {
    clearCartSyncTimer();

    if (cartSyncPromise) {
      cartSyncDirty = true;
      return cartSyncPromise;
    }

    const promise = (async () => {
      let guard = 0;

      while ((desiredQuantities.size > 0 || cartSyncDirty) && guard < 12) {
        cartSyncDirty = false;
        cleanupDesiredQuantities();
        const ids = [...desiredQuantities.keys()];
        if (!ids.length) break;

        for (const id of ids) {
          await syncOneQuantity(id);
        }

        cleanupDesiredQuantities();
        guard += 1;
      }

      if (desiredQuantities.size > 0) {
        throw new Error("Cart quantities did not finish syncing.");
      }
    })();

    cartSyncPromise = promise;
    try {
      await promise;
    } finally {
      if (cartSyncPromise === promise) cartSyncPromise = null;
      if (cartSyncDirty && desiredQuantities.size > 0) scheduleCartSync(null, 0);
    }

    return promise;
  }

  function changeQuantity(variantId, quantity) {
    captureScrollBeforeQuantityChange();
    clearWarnings();
    applyOptimisticQuantity(variantId, quantity);
    scheduleCartSync(variantId);
  }

  async function flushPendingQuantities() {
    clearCartSyncTimer();

    let guard = 0;
    while ((desiredQuantities.size > 0 || cartSyncPromise) && guard < 8) {
      if (cartSyncPromise) {
        await cartSyncPromise;
      } else {
        await syncPendingQuantities();
      }
      cleanupDesiredQuantities();
      guard += 1;
    }

    if (desiredQuantities.size > 0 || cartSyncPromise) {
      throw new Error("Cart quantities are still syncing.");
    }
  }

  async function cleanLegacyCheckoutProperties() {
    const lines = Array.isArray(cart.items)
      ? cart.items
        .map((item) => ({ item, properties: cleanLegacyLineProperties(item) }))
        .filter((entry) => entry.properties)
      : [];
    if (!lines.length) return;

    for (const { item, properties } of lines) {
      const response = await fetch("/cart/change.js", {
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: item.key || item.id,
          quantity: item.quantity,
          properties
        })
      });
      if (!response.ok) throw new Error(`Legacy checkout property cleanup failed: ${response.status}`);
    }

    await fetchCart({ preservePending: true });
  }

  function currentNote() {
    return nodes.notes[0]?.value || "";
  }

  function clearNoteSyncTimer() {
    if (noteSyncTimer) window.clearTimeout(noteSyncTimer);
    noteSyncTimer = null;
  }

  function scheduleNoteSync(delay = 700) {
    clearNoteSyncTimer();
    noteDirty = currentNote() !== syncedNote;
    if (!noteDirty) return;

    noteSyncTimer = window.setTimeout(() => {
      noteSyncTimer = null;
      syncNote().catch((error) => {
        console.error("[DCO] Cart note update failed", error);
      });
    }, delay);
  }

  async function syncNote() {
    clearNoteSyncTimer();

    if (noteSyncPromise) {
      await noteSyncPromise;
      if (currentNote() === syncedNote) {
        noteDirty = false;
        return;
      }
    }

    const note = currentNote();
    if (note === syncedNote) {
      noteDirty = false;
      return;
    }

    const promise = (async () => {
      const response = await fetch("/cart/update.js", {
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ note })
      });
      if (!response.ok) throw new Error(`Cart note update failed: ${response.status}`);
      syncedNote = note;
      cart.note = note;
      noteDirty = currentNote() !== syncedNote;
    })();

    noteSyncPromise = promise;
    try {
      await promise;
    } finally {
      if (noteSyncPromise === promise) noteSyncPromise = null;
    }

    if (currentNote() !== syncedNote) await syncNote();
  }

  async function updateNote() {
    await syncNote();
  }

  function clearQuantityTimer(input) {
    const variantId = input.dataset.dcoQtyInput;
    const timer = quantityTimers.get(variantId);
    if (timer) window.clearTimeout(timer);
    quantityTimers.delete(variantId);
  }

  function commitQuantityInput(input) {
    clearQuantityTimer(input);
    const variantId = input.dataset.dcoQtyInput;
    const qty = normalizeQuantity(input.value, input.dataset.step);
    input.value = qty;
    if (qty !== displayedQuantityFor(variantId)) changeQuantity(variantId, qty);
  }

  function scheduleQuantityInput(input) {
    clearQuantityTimer(input);
    if (input.value.trim() === "") return;
    const variantId = input.dataset.dcoQtyInput;
    quantityTimers.set(variantId, window.setTimeout(() => {
      commitQuantityInput(input);
    }, 450));
  }

  function renderProductInputs() {
    productNodes.forEach((group, id) => {
      const qty = displayedQuantityFor(id);
      const value = String(qty);
      const liveInputs = [...new Set([
        ...group.inputs,
        ...root.querySelectorAll(`[data-dco-qty-input="${id}"]`)
      ])];
      liveInputs.forEach((input) => {
        if (document.activeElement !== input && input.value !== value) input.value = value;
      });
      group.cards.forEach((card) => {
        const isSelected = qty > 0;
        if (card.classList.contains("is-selected") !== isSelected) {
          card.classList.toggle("is-selected", isSelected);
        }
      });
    });
  }

  function renderLines() {
    const items = displayCartItems();
    const structure = items.length ? items.map((item) => String(item.id)).join("|") : "empty";

    if (structure !== renderedLineStructure) {
      const html = items.length
        ? items.map((item) => {
            const id = String(item.id);
            const product = productByVariant.get(id);
            const step = product ? Number(product.step || 1) : 1;
            const titleText = cartItemTitle(item);
            const title = escapeHtml(titleText);
            const meta = escapeHtml(`${item.quantity} × ${money(item.final_price)}`);
            return `
              <div class="dco-cart-line" data-dco-cart-line="${escapeHtml(id)}">
                <div>
                  <div class="dco-cart-line__title" data-dco-line-title>${title}</div>
                  <div class="dco-cart-line__meta" data-dco-line-meta>${meta}</div>
                </div>
                <div class="dco-cart-line__controls">
                  <div class="dco-cart-qty">
                    <button type="button" data-dco-minus="${escapeHtml(id)}" aria-label="${escapeHtml(`${strings.decrease} ${titleText}`)}">−</button>
                    <input type="tel" inputmode="numeric" pattern="[0-9]*" value="${escapeHtml(item.quantity)}" data-dco-qty-input="${escapeHtml(id)}" data-step="${escapeHtml(step)}" aria-label="${escapeHtml(`${strings.chooseQuantity} ${titleText}`)}">
                    <button type="button" data-dco-plus="${escapeHtml(id)}" aria-label="${escapeHtml(`${strings.increase} ${titleText}`)}">+</button>
                  </div>
                  <button class="dco-cart-line__remove" type="button" data-dco-remove="${escapeHtml(id)}" aria-label="${escapeHtml(`${strings.remove} ${titleText}`)}">×</button>
                </div>
              </div>
            `;
          }).join("")
        : `<div class="dco-empty">${strings.empty}</div>`;

      nodes.cartLines.forEach((node) => {
        node.innerHTML = html;
      });
      renderedLineStructure = structure;
      return;
    }

    if (!items.length) return;

    nodes.cartLines.forEach((container) => {
      items.forEach((item) => {
        const id = String(item.id);
        const line = container.querySelector(`[data-dco-cart-line="${id}"]`);
        if (!line) return;
        const title = cartItemTitle(item);
        const titleNode = line.querySelector("[data-dco-line-title]");
        if (titleNode && titleNode.textContent !== title) titleNode.textContent = title;
        const meta = `${item.quantity} × ${money(item.final_price)}`;
        const metaNode = line.querySelector("[data-dco-line-meta]");
        if (metaNode && metaNode.textContent !== meta) metaNode.textContent = meta;
        const input = line.querySelector("[data-dco-qty-input]");
        const value = String(item.quantity);
        if (input && document.activeElement !== input && input.value !== value) input.value = value;
      });
    });
  }

  function renderSummary() {
    const summary = displayCartSummary();
    const total = summary.total;
    const count = summary.count;
    const shippingValue = total >= shipping ? strings.free : "$10";
    const earnedGifts = giftMultiplier(total);
    const reachedGift = earnedGifts > 0;
    const showGiftRow = gift > 0 && total >= minimum;
    const checkoutText = checkoutHandoffActive
      ? strings.checkoutLoading
      : total >= minimum ? strings.checkout : template(strings.locked, minimum - total);
    const state = milestoneState(total);
    const giftValue = reachedGift
      ? giftDescription(earnedGifts)
      : template(strings.giftNudge, gift - total);
    const minimumTierLabel = total >= minimum ? strings.minimumTierReached : strings.minimumTierPending;
    const promoGiftMultiplier = Math.max(1, earnedGifts);
    const promoGiftThreshold = gift * promoGiftMultiplier;

    setText(nodes.counts, `${count} ${strings.items}`);
    setText(nodes.subtotals, money(total));
    setText(nodes.shipping, shippingValue);
    nodes.shipping.forEach((node) => {
      const row = node.closest(".dco-summary-row");
      if (row && row.classList.contains("is-free") !== (total >= shipping)) {
        row.classList.toggle("is-free", total >= shipping);
      }
    });
    setText(nodes.messages, nextMilestoneText(total));
    setText(nodes.bottomMessages, bottomText(total));
    setText(nodes.checkouts, checkoutText);
    setText(nodes.minimumTierLabels, minimumTierLabel);
    nodes.checkoutButtons.forEach((node) => {
      node.disabled = false;
      node.removeAttribute("disabled");
      node.classList.toggle("is-loading", checkoutHandoffActive);
      if (checkoutHandoffActive) {
        node.setAttribute("aria-busy", "true");
        node.setAttribute("aria-disabled", "true");
      } else {
        node.removeAttribute("aria-busy");
        node.removeAttribute("aria-disabled");
      }
    });
    nodes.checkoutCounts.forEach((node) => {
      const showCount = !checkoutHandoffActive && total >= minimum && count > 0;
      const countText = `· ${count} ${strings.items}`;
      if (node.textContent !== countText) node.textContent = countText;
      if (node.hidden !== !showCount) node.hidden = !showCount;
    });
    if (root.dataset.dcoMilestone !== state) root.dataset.dcoMilestone = state;

    nodes.giftRows.forEach((node) => {
      if (node.classList.contains("is-hidden") === showGiftRow) node.classList.toggle("is-hidden", !showGiftRow);
      node.classList.toggle("is-earned", reachedGift);
      node.classList.toggle("is-pending", showGiftRow && !reachedGift);
    });
    setText(nodes.giftValues, giftValue);
    setText(nodes.giftTierLabels, promoGiftDescription(promoGiftMultiplier));
    setText(nodes.giftTierValues, money(promoGiftThreshold));
    if (nodes.giftTier && Number(nodes.giftTier.dataset.dcoTier) !== promoGiftThreshold) {
      nodes.giftTier.dataset.dcoTier = String(promoGiftThreshold);
    }

    const fillTransform = `scaleX(${progress(total) / 100})`;
    nodes.promoFills.forEach((node) => {
      if (node.style.transform !== fillTransform) node.style.transform = fillTransform;
    });

    nodes.promoMarkers.forEach((node) => {
      const tier = Number(node.dataset.dcoPromoMarker || 0);
      const left = gift > 0 ? Math.max(0, Math.min(100, (tier / gift) * 100)) : 100;
      const leftValue = `${left}%`;
      if (node.style.getPropertyValue("--dco-marker-left") !== leftValue) {
        node.style.setProperty("--dco-marker-left", leftValue);
      }
      if (node.classList.contains("is-active") !== (total >= tier)) {
        node.classList.toggle("is-active", total >= tier);
      }
    });

    nodes.tiers.forEach((node) => {
      const isActive = total >= Number(node.dataset.dcoTier);
      if (node.classList.contains("is-active") !== isActive) node.classList.toggle("is-active", isActive);
    });
  }

  function render() {
    renderProductInputs();
    renderLines();
    renderSummary();
  }

  function sheetDragDistance(distance) {
    if (distance <= 0) return 0;
    if (distance <= 150) return distance;
    return 150 + (distance - 150) * 0.32;
  }

  function setSheetDrag(node, distance) {
    if (!node) return;
    const drag = sheetDragDistance(distance);
    node.style.setProperty("--dco-sheet-translate-y", `${drag}px`);
    node.classList.toggle("is-dragging", drag > 0);
  }

  function resetSheetDrag(node) {
    if (!node) return;
    node.classList.remove("is-dragging", "is-dismissing");
    node.style.removeProperty("--dco-sheet-translate-y");
  }

  function dismissSheet(node, closeCallback) {
    if (!node) {
      closeCallback();
      return;
    }
    const dismissDistance = Math.ceil(node.getBoundingClientRect().height + 32);
    node.classList.remove("is-dragging");
    node.classList.add("is-dismissing");
    node.getBoundingClientRect();
    window.requestAnimationFrame(() => {
      node.style.setProperty("--dco-sheet-translate-y", `${dismissDistance}px`);
    });
    window.setTimeout(() => {
      closeCallback();
      resetSheetDrag(node);
    }, 320);
  }

  function shouldIgnoreSheetSwipe(target) {
    return Boolean(target?.closest?.("input, textarea, select, option"));
  }

  function isDismissSwipe(totalY, totalX) {
    return totalY > 10 && Math.abs(totalY) > Math.abs(totalX) * 1.25;
  }

  function openDrawer() {
    resetSheetDrag(nodes.drawer);
    if (nodes.drawerBody) nodes.drawerBody.scrollTop = 0;
    lockDrawerPageScroll();
    window.requestAnimationFrame(() => {
      nodes.drawer?.classList.add("is-open");
      nodes.drawerBackdrop?.classList.add("is-open");
    });
  }

  function closeDrawer() {
    resetSheetDrag(nodes.drawer);
    nodes.drawer?.classList.remove("is-open");
    nodes.drawerBackdrop?.classList.remove("is-open");
    unlockDrawerPageScroll();
  }

  function closeDrawerAnimated() {
    if (nodes.drawer?.classList.contains("is-dismissing")) return;
    if (!nodes.drawer?.classList.contains("is-open")) {
      closeDrawer();
      return;
    }
    dismissSheet(nodes.drawer, closeDrawer);
  }

  function lockDrawerPageScroll() {
    if (drawerScrollLocked) return;
    drawerScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    drawerHtmlScrollSnapshot = {
      overflow: document.documentElement.style.overflow,
      height: document.documentElement.style.height
    };
    drawerBodyScrollSnapshot = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
      height: document.body.style.height
    };
    document.documentElement.classList.add("dco-drawer-scroll-locked");
    document.body.classList.add("dco-drawer-scroll-locked");
    document.body.style.setProperty("--dco-drawer-page-offset", `-${drawerScrollY}px`);
    document.body.style.setProperty("--dco-drawer-page-height", `${Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)}px`);
    window.requestAnimationFrame(() => window.scrollTo(0, drawerScrollY));
    window.setTimeout(() => window.scrollTo(0, drawerScrollY), 0);
    document.addEventListener("pointerdown", handleDrawerPointerStart, { passive: true });
    document.addEventListener("pointermove", handleDrawerPointerMove, { passive: false });
    document.addEventListener("pointerup", handleDrawerPointerEnd, { passive: true });
    document.addEventListener("pointercancel", handleDrawerPointerEnd, { passive: true });
    document.addEventListener("touchstart", handleDrawerTouchStart, { passive: true });
    document.addEventListener("touchmove", handleDrawerTouchMove, { passive: false });
    document.addEventListener("touchend", handleDrawerTouchEnd, { passive: true });
    document.addEventListener("touchcancel", handleDrawerTouchEnd, { passive: true });
    document.addEventListener("wheel", handleDrawerWheel, { passive: false });
    drawerScrollLocked = true;
  }

  function unlockDrawerPageScroll() {
    if (!drawerScrollLocked) return;
    document.removeEventListener("touchstart", handleDrawerTouchStart);
    document.removeEventListener("touchmove", handleDrawerTouchMove);
    document.removeEventListener("touchend", handleDrawerTouchEnd);
    document.removeEventListener("touchcancel", handleDrawerTouchEnd);
    document.removeEventListener("pointerdown", handleDrawerPointerStart);
    document.removeEventListener("pointermove", handleDrawerPointerMove);
    document.removeEventListener("pointerup", handleDrawerPointerEnd);
    document.removeEventListener("pointercancel", handleDrawerPointerEnd);
    document.removeEventListener("wheel", handleDrawerWheel);
    document.documentElement.classList.remove("dco-drawer-scroll-locked");
    document.body.classList.remove("dco-drawer-scroll-locked");
    if (drawerHtmlScrollSnapshot) {
      Object.entries(drawerHtmlScrollSnapshot).forEach(([property, value]) => {
        document.documentElement.style[property] = value;
      });
    }
    if (drawerBodyScrollSnapshot) {
      Object.entries(drawerBodyScrollSnapshot).forEach(([property, value]) => {
        document.body.style[property] = value;
      });
    }
    drawerScrollLocked = false;
    drawerSwipeActive = false;
    drawerSwipeDistance = 0;
    drawerHtmlScrollSnapshot = null;
    drawerBodyScrollSnapshot = null;
    document.body.style.removeProperty("--dco-drawer-page-offset");
    document.body.style.removeProperty("--dco-drawer-page-height");
    window.scrollTo(0, drawerScrollY);
  }

  function scrollableDrawerNode(target, intendedDeltaY = 0) {
    if (!nodes.drawerBody || !target || !nodes.drawerBody.contains(target)) return null;

    let node = target;
    while (node && node !== nodes.drawerBody && node !== document.body) {
      if (node instanceof HTMLElement) {
        const style = window.getComputedStyle(node);
        const canScroll = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
        const atTop = node.scrollTop <= 0;
        const atBottom = Math.ceil(node.scrollTop + node.clientHeight) >= node.scrollHeight;
        if (canScroll && (intendedDeltaY === 0 || (intendedDeltaY < 0 && !atTop) || (intendedDeltaY > 0 && !atBottom))) return node;
      }
      node = node.parentElement;
    }

    if (nodes.drawerBody.scrollHeight <= nodes.drawerBody.clientHeight) return null;
    const atTop = nodes.drawerBody.scrollTop <= 0;
    const atBottom = Math.ceil(nodes.drawerBody.scrollTop + nodes.drawerBody.clientHeight) >= nodes.drawerBody.scrollHeight;
    if (intendedDeltaY < 0 && atTop) return null;
    if (intendedDeltaY > 0 && atBottom) return null;
    return nodes.drawerBody;
  }

  function handleDrawerTouchStart(event) {
    if (!drawerScrollLocked) return;
    const touch = event.touches?.[0];
    drawerTouchStartY = touch?.clientY || 0;
    drawerTouchLastY = drawerTouchStartY;
    drawerTouchStartX = touch?.clientX || 0;
    drawerSwipeActive = false;
    drawerSwipeDistance = 0;
    resetSheetDrag(nodes.drawer);
  }

  function handleDrawerTouchMove(event) {
    if (!drawerScrollLocked) return;
    const touch = event.touches?.[0];
    const currentY = touch?.clientY || drawerTouchLastY;
    const currentX = touch?.clientX || drawerTouchStartX;
    const totalY = currentY - drawerTouchStartY;
    const totalX = currentX - drawerTouchStartX;
    const intendedDeltaY = drawerTouchLastY - currentY;

    if (drawerSwipeActive) {
      drawerSwipeDistance = Math.max(0, totalY);
      setSheetDrag(nodes.drawer, drawerSwipeDistance);
      event.preventDefault();
      return;
    }

    const scrollNode = scrollableDrawerNode(event.target, intendedDeltaY);
    if (!scrollNode && !shouldIgnoreSheetSwipe(event.target) && isDismissSwipe(totalY, totalX)) {
      drawerSwipeActive = true;
      drawerSwipeDistance = totalY;
      setSheetDrag(nodes.drawer, drawerSwipeDistance);
      event.preventDefault();
      return;
    }

    if (!scrollNode) {
      event.preventDefault();
      return;
    }

    drawerTouchLastY = currentY;
  }

  function handleDrawerTouchEnd() {
    if (!drawerSwipeActive) return;
    const shouldClose = drawerSwipeDistance > 88;
    drawerSwipeActive = false;
    drawerSwipeDistance = 0;
    if (shouldClose) {
      dismissSheet(nodes.drawer, closeDrawer);
    } else {
      resetSheetDrag(nodes.drawer);
    }
  }

  function handleDrawerPointerStart(event) {
    if (!drawerScrollLocked || event.pointerType !== "mouse" || !nodes.drawer?.contains(event.target)) return;
    drawerTouchStartY = event.clientY || 0;
    drawerTouchLastY = drawerTouchStartY;
    drawerTouchStartX = event.clientX || 0;
    drawerSwipeActive = false;
    drawerSwipeDistance = 0;
    resetSheetDrag(nodes.drawer);
  }

  function handleDrawerPointerMove(event) {
    if (!drawerScrollLocked || event.pointerType !== "mouse" || (!drawerSwipeActive && !nodes.drawer?.contains(event.target))) return;
    const currentY = event.clientY || drawerTouchLastY;
    const currentX = event.clientX || drawerTouchStartX;
    const totalY = currentY - drawerTouchStartY;
    const totalX = currentX - drawerTouchStartX;
    const intendedDeltaY = drawerTouchLastY - currentY;

    if (drawerSwipeActive) {
      drawerSwipeDistance = Math.max(0, totalY);
      setSheetDrag(nodes.drawer, drawerSwipeDistance);
      event.preventDefault();
      return;
    }

    const scrollNode = scrollableDrawerNode(event.target, intendedDeltaY);
    if (!scrollNode && !shouldIgnoreSheetSwipe(event.target) && isDismissSwipe(totalY, totalX)) {
      drawerSwipeActive = true;
      drawerSwipeDistance = totalY;
      setSheetDrag(nodes.drawer, drawerSwipeDistance);
      event.preventDefault();
      return;
    }

    drawerTouchLastY = currentY;
  }

  function handleDrawerPointerEnd(event) {
    if (event.pointerType !== "mouse") return;
    handleDrawerTouchEnd();
  }

  function handleDrawerWheel(event) {
    if (!drawerScrollLocked) return;
    const scrollNode = scrollableDrawerNode(event.target, event.deltaY);
    if (!scrollNode) {
      event.preventDefault();
      return;
    }
  }

  function lockDetailsPageScroll() {
    if (detailsScrollLocked) return;
    detailsScrollX = window.scrollX || document.documentElement.scrollLeft || 0;
    detailsScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    detailsUsesFixedScrollLock = isMobileSheetViewport();
    htmlScrollSnapshot = {
      overflow: document.documentElement.style.overflow,
      height: document.documentElement.style.height
    };
    bodyScrollSnapshot = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
      height: document.body.style.height
    };
    document.documentElement.classList.add("dco-details-scroll-locked");
    document.body.classList.add("dco-details-scroll-locked");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    if (detailsUsesFixedScrollLock) {
      document.documentElement.style.height = "100%";
      document.body.style.position = "fixed";
      document.body.style.top = `-${detailsScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      window.requestAnimationFrame(() => window.scrollTo(detailsScrollX, detailsScrollY));
      window.setTimeout(() => window.scrollTo(detailsScrollX, detailsScrollY), 0);
    }
    document.addEventListener("touchstart", handleDetailsTouchStart, { passive: true });
    document.addEventListener("touchmove", handleDetailsTouchMove, { passive: false });
    document.addEventListener("touchend", handleDetailsTouchEnd, { passive: true });
    document.addEventListener("touchcancel", handleDetailsTouchEnd, { passive: true });
    document.addEventListener("wheel", handleDetailsWheel, { passive: false });
    detailsScrollLocked = true;
  }

  function unlockDetailsPageScroll() {
    if (!detailsScrollLocked) return;
    const shouldRestoreScrollPosition = detailsUsesFixedScrollLock;
    document.removeEventListener("touchstart", handleDetailsTouchStart);
    document.removeEventListener("touchmove", handleDetailsTouchMove);
    document.removeEventListener("touchend", handleDetailsTouchEnd);
    document.removeEventListener("touchcancel", handleDetailsTouchEnd);
    document.removeEventListener("wheel", handleDetailsWheel);
    document.documentElement.classList.remove("dco-details-scroll-locked");
    document.body.classList.remove("dco-details-scroll-locked");
    if (htmlScrollSnapshot) {
      Object.entries(htmlScrollSnapshot).forEach(([property, value]) => {
        document.documentElement.style[property] = value;
      });
    }
    if (bodyScrollSnapshot) {
      Object.entries(bodyScrollSnapshot).forEach(([property, value]) => {
        document.body.style[property] = value;
      });
    }
    detailsScrollLocked = false;
    detailsUsesFixedScrollLock = false;
    detailsSwipeActive = false;
    detailsSwipeDistance = 0;
    htmlScrollSnapshot = null;
    bodyScrollSnapshot = null;
    if (shouldRestoreScrollPosition) window.scrollTo(detailsScrollX, detailsScrollY);
  }

  function detailsScrollContainer(target) {
    return target?.closest?.("[data-dco-details-body]");
  }

  function handleDetailsTouchStart(event) {
    if (!detailsScrollLocked) return;
    const touch = event.touches?.[0];
    detailsTouchStartY = touch?.clientY || 0;
    detailsTouchLastY = detailsTouchStartY;
    detailsTouchStartX = touch?.clientX || 0;
    detailsSwipeActive = false;
    detailsSwipeDistance = 0;
    resetSheetDrag(nodes.detailsModal);
  }

  function handleDetailsTouchMove(event) {
    if (!detailsScrollLocked) return;
    const touch = event.touches?.[0];
    const currentY = touch?.clientY || detailsTouchLastY;
    const currentX = touch?.clientX || detailsTouchStartX;
    const totalY = currentY - detailsTouchStartY;
    const totalX = currentX - detailsTouchStartX;
    const intendedDeltaY = detailsTouchLastY - currentY;

    if (detailsSwipeActive) {
      detailsSwipeDistance = Math.max(0, totalY);
      setSheetDrag(nodes.detailsModal, detailsSwipeDistance);
      event.preventDefault();
      return;
    }

    const scrollNode = detailsScrollContainer(event.target);
    const canScroll = scrollNode && scrollNode.scrollHeight > scrollNode.clientHeight;
    const atTop = !scrollNode || scrollNode.scrollTop <= 0;
    const atBottom = scrollNode && Math.ceil(scrollNode.scrollTop + scrollNode.clientHeight) >= scrollNode.scrollHeight;
    if (
      nodes.detailsModal?.contains(event.target)
      && !shouldIgnoreSheetSwipe(event.target)
      && isDismissSwipe(totalY, totalX)
      && (!scrollNode || !canScroll || (atTop && intendedDeltaY < 0))
    ) {
      detailsSwipeActive = true;
      detailsSwipeDistance = totalY;
      setSheetDrag(nodes.detailsModal, detailsSwipeDistance);
      event.preventDefault();
      return;
    }

    if (!scrollNode) {
      event.preventDefault();
      return;
    }

    const deltaY = currentY - detailsTouchLastY;
    detailsTouchLastY = currentY;
    if (!canScroll || (atTop && deltaY > 0) || (atBottom && deltaY < 0)) event.preventDefault();
  }

  function handleDetailsTouchEnd() {
    if (!detailsSwipeActive) return;
    const shouldClose = detailsSwipeDistance > 88;
    detailsSwipeActive = false;
    detailsSwipeDistance = 0;
    if (shouldClose) {
      dismissSheet(nodes.detailsModal, closeDetails);
    } else {
      resetSheetDrag(nodes.detailsModal);
    }
  }

  function handleDetailsPointerStart(event) {
    if (!detailsScrollLocked || event.pointerType !== "mouse" || !nodes.detailsModal?.contains(event.target)) return;
    detailsTouchStartY = event.clientY || 0;
    detailsTouchLastY = detailsTouchStartY;
    detailsTouchStartX = event.clientX || 0;
    detailsSwipeActive = false;
    detailsSwipeDistance = 0;
    resetSheetDrag(nodes.detailsModal);
  }

  function handleDetailsPointerMove(event) {
    if (!detailsScrollLocked || event.pointerType !== "mouse" || (!detailsSwipeActive && !nodes.detailsModal?.contains(event.target))) return;
    const currentY = event.clientY || detailsTouchLastY;
    const currentX = event.clientX || detailsTouchStartX;
    const totalY = currentY - detailsTouchStartY;
    const totalX = currentX - detailsTouchStartX;
    const intendedDeltaY = detailsTouchLastY - currentY;

    if (detailsSwipeActive) {
      detailsSwipeDistance = Math.max(0, totalY);
      setSheetDrag(nodes.detailsModal, detailsSwipeDistance);
      event.preventDefault();
      return;
    }

    const scrollNode = detailsScrollContainer(event.target);
    const canScroll = scrollNode && scrollNode.scrollHeight > scrollNode.clientHeight;
    const atTop = !scrollNode || scrollNode.scrollTop <= 0;
    if (
      !shouldIgnoreSheetSwipe(event.target)
      && isDismissSwipe(totalY, totalX)
      && (!scrollNode || !canScroll || (atTop && intendedDeltaY < 0))
    ) {
      detailsSwipeActive = true;
      detailsSwipeDistance = totalY;
      setSheetDrag(nodes.detailsModal, detailsSwipeDistance);
      event.preventDefault();
      return;
    }

    detailsTouchLastY = currentY;
  }

  function handleDetailsPointerEnd(event) {
    if (event.pointerType !== "mouse") return;
    handleDetailsTouchEnd();
  }

  function handleDetailsWheel(event) {
    if (!detailsScrollLocked) return;
    const scrollNode = detailsScrollContainer(event.target);
    if (!scrollNode) {
      event.preventDefault();
      return;
    }

    const canScroll = scrollNode.scrollHeight > scrollNode.clientHeight;
    const atTop = scrollNode.scrollTop <= 0;
    const atBottom = Math.ceil(scrollNode.scrollTop + scrollNode.clientHeight) >= scrollNode.scrollHeight;
    if (!canScroll || (atTop && event.deltaY < 0) || (atBottom && event.deltaY > 0)) event.preventDefault();
  }

  function detailFact(label, value) {
    if (!value) return "";
    return `
      <div class="dco-details-modal__fact">
        <b>${escapeHtml(label)}</b>
        <p>${formatText(value)}</p>
      </div>
    `;
  }

  function renderDetailsGallery(product) {
    const images = Array.isArray(product.images) ? product.images.filter((image) => image && image.src) : [];
    if (!images.length) return "";
    const first = images[0];
    const thumbs = images.length > 1
      ? `<div class="dco-details-modal__thumbs">
          ${images.map((image, index) => `
            <button type="button" data-dco-detail-thumb data-src="${escapeHtml(image.src)}" data-alt="${escapeHtml(image.alt || product.title)}" aria-label="${escapeHtml(`${product.title} photo ${index + 1}`)}">
              <img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt || product.title)}" loading="lazy">
            </button>
          `).join("")}
        </div>`
      : "";

    return `
      <div class="dco-details-modal__media">
        <img data-dco-details-image src="${escapeHtml(first.src)}" alt="${escapeHtml(first.alt || product.title)}">
        ${thumbs}
      </div>
    `;
  }

  function renderDetailsActions(product, variantId, qty, step) {
    return `
      <div class="dco-details-modal__quantity">
        <span>${strings.chooseQuantity}</span>
        <div class="dco-qty" aria-label="${escapeHtml(`${strings.chooseQuantity} ${product.title}`)}">
          <button type="button" data-dco-minus="${escapeHtml(variantId)}" aria-label="${escapeHtml(`${strings.decrease} ${product.title}`)}">−</button>
          <input type="tel" inputmode="numeric" pattern="[0-9]*" autocomplete="off" enterkeyhint="done" value="${escapeHtml(qty)}" data-dco-qty-input="${escapeHtml(variantId)}" data-step="${escapeHtml(step)}" aria-label="${escapeHtml(`${strings.chooseQuantity} ${product.title}`)}">
          <button type="button" data-dco-plus="${escapeHtml(variantId)}" aria-label="${escapeHtml(`${strings.increase} ${product.title}`)}">+</button>
        </div>
      </div>
      <button class="dco-details-modal__return" type="button" data-dco-close-details>${strings.orderMore}</button>
    `;
  }

  function openDetails(variantId, trigger) {
    const product = productByVariant.get(String(variantId));
    if (!product || !nodes.detailsModal || !nodes.detailsBody) return;

    resetSheetDrag(nodes.detailsModal);
    lastDetailsTrigger = trigger || document.activeElement;
    const step = Number(product.step || 1);
    const qty = displayedQuantityFor(variantId);
    const actions = renderDetailsActions(product, variantId, qty, step);
    if (nodes.detailsTitle) nodes.detailsTitle.textContent = product.title;
    nodes.detailsBody.innerHTML = `
      ${renderDetailsGallery(product)}
      <div class="dco-details-modal__copy">
        <div class="dco-details-modal__price">${money(Number(product.price || 0))}</div>
        ${product.summary ? `<p class="dco-details-modal__summary">${formatText(product.summary)}</p>` : ""}
        <div class="dco-details-modal__actions dco-details-modal__actions--inline">
          ${actions}
        </div>
        <div class="dco-details-modal__facts">
          ${detailFact(strings.reheating, product.reheating)}
          ${detailFact(strings.storage, product.storage)}
          ${detailFact(strings.allergens, product.allergens)}
        </div>
      </div>
    `;
    if (nodes.detailsFooter) {
      nodes.detailsFooter.innerHTML = `
        <div class="dco-details-modal__actions dco-details-modal__actions--footer">
          ${actions}
        </div>
      `;
    }
    nodes.detailsBody.scrollTop = 0;

    lockDetailsPageScroll();
    window.requestAnimationFrame(() => {
      nodes.detailsModal.classList.add("is-open");
      nodes.detailsModal.setAttribute("aria-hidden", "false");
      nodes.detailsBackdrop?.classList.add("is-open");
      const closeButton = nodes.detailsModal.querySelector("[data-dco-close-details]");
      if (closeButton) {
        try {
          closeButton.focus({ preventScroll: true });
        } catch (error) {
          closeButton.focus();
        }
      }
    });
    renderProductInputs();
  }

  function closeDetails() {
    resetSheetDrag(nodes.detailsModal);
    nodes.detailsModal?.classList.remove("is-open");
    nodes.detailsModal?.setAttribute("aria-hidden", "true");
    nodes.detailsBackdrop?.classList.remove("is-open");
    if (nodes.detailsFooter) nodes.detailsFooter.innerHTML = "";
    unlockDetailsPageScroll();
    if (lastDetailsTrigger && document.contains(lastDetailsTrigger)) {
      try {
        lastDetailsTrigger.focus({ preventScroll: true });
      } catch (error) {
        lastDetailsTrigger.focus();
      }
    }
    lastDetailsTrigger = null;
  }

  function updateDetailsImage(button) {
    const image = nodes.detailsModal?.querySelector("[data-dco-details-image]");
    if (!image) return;
    image.src = button.dataset.src || image.src;
    image.alt = button.dataset.alt || image.alt;
  }

  function warningTarget(trigger) {
    return trigger?.closest(".dco-cart, .dco-drawer")?.querySelector("[data-dco-warning]") || nodes.warnings[0];
  }

  function bringWarningIntoView(node) {
    if (!node) return;
    const rect = node.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    if (!isVisible) node.scrollIntoView({ block: "nearest" });
  }

  function showWarning(trigger) {
    const target = warningTarget(trigger);
    const warningText = template(strings.minWarning, minimum - (cart.total_price || 0));
    nodes.warnings.forEach((node) => {
      if (node.textContent !== warningText) node.textContent = warningText;
      if (!node.classList.contains("is-visible")) node.classList.add("is-visible");
    });
    bringWarningIntoView(target);
  }

  function setCheckoutHandoffActive(value) {
    if (checkoutHandoffActive === value) return;
    checkoutHandoffActive = value;
    renderSummary();
  }

  function startCheckoutHandoffAnimation() {
    window.clearTimeout(checkoutHandoffTimer);
    setCheckoutHandoffActive(true);
    checkoutHandoffTimer = window.setTimeout(() => {
      checkoutHandoffTimer = null;
      setCheckoutHandoffActive(false);
    }, 550);
  }

  function clearCheckoutHandoffAnimation() {
    window.clearTimeout(checkoutHandoffTimer);
    checkoutHandoffTimer = null;
    checkoutHandoffActive = false;
    renderSummary();
  }

  function restoreCheckoutControls() {
    checkoutRequestActive = false;
    checkoutHandoffActive = false;
    window.clearTimeout(checkoutHandoffTimer);
    checkoutHandoffTimer = null;
    nodes.checkoutButtons.forEach((node) => {
      node.disabled = false;
      node.removeAttribute("disabled");
      node.classList.remove("is-loading");
      node.removeAttribute("aria-busy");
      node.removeAttribute("aria-disabled");
    });
    renderSummary();
  }

  function scheduleCheckoutRestore() {
    restoreCheckoutControls();
    window.requestAnimationFrame(restoreCheckoutControls);
    window.setTimeout(restoreCheckoutControls, 120);
    window.setTimeout(restoreCheckoutControls, 750);
  }

  async function checkout(trigger) {
    if (checkoutRequestActive) {
      startCheckoutHandoffAnimation();
      return;
    }

    if ((cart.total_price || 0) < minimum && desiredQuantities.size === 0 && !cartSyncPromise) {
      showWarning(trigger);
      return;
    }

    checkoutRequestActive = true;
    startCheckoutHandoffAnimation();
    try {
      await flushPendingQuantities();
      if ((cart.total_price || 0) < minimum) {
        checkoutRequestActive = false;
        clearCheckoutHandoffAnimation();
        showWarning(trigger);
        return;
      }
      await Promise.all([cleanLegacyCheckoutProperties(), updateNote()]);
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("[DCO] Checkout handoff failed", error);
      checkoutRequestActive = false;
      clearCheckoutHandoffAnimation();
      showCartError(strings.cartError);
    }
  }

  root.addEventListener("pointerdown", captureScrollBeforeQuantityPointer, { passive: true });
  root.addEventListener("touchstart", captureScrollBeforeQuantityPointer, { passive: true });
  window.addEventListener("touchmove", cancelScrollRestoreAfterUserMove, { passive: true });
  window.addEventListener("wheel", cancelScrollRestoreAfterUserMove, { passive: true });

  root.addEventListener("click", (event) => {
    const plus = event.target.closest("[data-dco-plus]");
    const minus = event.target.closest("[data-dco-minus]");
    const remove = event.target.closest("[data-dco-remove]");
    const open = event.target.closest("[data-dco-open-cart]");
    const close = event.target.closest("[data-dco-close-cart]");
    const openDetailsButton = event.target.closest("[data-dco-open-details]");
    const closeDetailsButton = event.target.closest("[data-dco-close-details]");
    const detailThumb = event.target.closest("[data-dco-detail-thumb]");
    const checkoutButton = event.target.closest("[data-dco-checkout]");

    if (plus) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = plus.dataset.dcoPlus;
      const product = productByVariant.get(String(variantId));
      const step = Number(product?.step || plus.parentElement.querySelector("input")?.dataset.step || 1);
      changeQuantity(variantId, displayedQuantityFor(variantId) + step);
      releaseQuantityButtonFocus(plus);
      return;
    }

    if (minus) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = minus.dataset.dcoMinus;
      const product = productByVariant.get(String(variantId));
      const step = Number(product?.step || minus.parentElement.querySelector("input")?.dataset.step || 1);
      changeQuantity(variantId, Math.max(0, displayedQuantityFor(variantId) - step));
      releaseQuantityButtonFocus(minus);
      return;
    }

    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      changeQuantity(remove.dataset.dcoRemove, 0);
      releaseQuantityButtonFocus(remove);
      return;
    }

    if (open) {
      event.preventDefault();
      event.stopPropagation();
      openDrawer();
      return;
    }

    if (close) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawerAnimated();
      return;
    }

    if (openDetailsButton) {
      event.preventDefault();
      event.stopPropagation();
      openDetails(openDetailsButton.dataset.dcoOpenDetails, openDetailsButton);
      return;
    }

    if (closeDetailsButton) {
      event.preventDefault();
      event.stopPropagation();
      closeDetails();
      return;
    }

    if (detailThumb) {
      event.preventDefault();
      event.stopPropagation();
      updateDetailsImage(detailThumb);
      return;
    }

    if (checkoutButton) {
      event.preventDefault();
      event.stopPropagation();
      checkout(checkoutButton);
    }
  });

  root.addEventListener("focusin", (event) => {
    if (event.target.matches("[data-dco-qty-input]")) event.target.select();
  });

  root.addEventListener("input", (event) => {
    const input = event.target.closest("[data-dco-qty-input]");
    if (!input) return;
    scheduleQuantityInput(input);
  });

  root.addEventListener("change", (event) => {
    const input = event.target.closest("[data-dco-qty-input]");
    if (!input) return;
    commitQuantityInput(input);
  });

  root.addEventListener("focusout", (event) => {
    const input = event.target.closest("[data-dco-qty-input]");
    if (!input) return;
    commitQuantityInput(input);
  });

  root.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") return;
    const input = event.target.closest("[data-dco-qty-input]");
    if (!input) return;
    event.preventDefault();
    commitQuantityInput(input);
    input.blur();
  });

  nodes.notes.forEach((node) => {
    node.addEventListener("input", () => {
      nodes.notes.forEach((other) => {
        if (other !== node) other.value = node.value;
      });
      noteDirty = node.value !== syncedNote;
      if (noteDirty) {
        scheduleNoteSync();
      } else {
        clearNoteSyncTimer();
      }
    });
  });

  document.addEventListener("keyup", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
      closeDetails();
    }
  });

  window.addEventListener("pageshow", scheduleCheckoutRestore);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") scheduleCheckoutRestore();
  });

  render();
  fetchCart({ preservePending: true })
    .then(() => cleanLegacyCheckoutProperties().catch((error) => {
      console.error("[DCO] Legacy checkout property cleanup failed", error);
    }))
    .catch((error) => {
      console.error("[DCO] Initial cart fetch failed", error);
      showCartError(strings.cartError);
    });
})();
